import React from 'react'
import AdminPanel from '../AdminPanel'
import {translationsAdminMenu, translationsNewAdminMenu, setttingsAdminMenu, usersListAdminMenu, discountsAdminMenu, plansAdminMenu, transactionsAdminMenu, feetbackAdminMenu, support} from "../../settings/routes"
import Translations from '../AdminPanel/Translations'
import TranslationItem from "../AdminPanel/TranslationItem"
import Settings from '../AdminPanel/Settings'
import UsersContainer from '../../containers/UsersListConatiner'
import Discounts from '../AdminPanel/Discounts'
import Plans from '../AdminPanel/Plans'
import Transaction from '../AdminPanel/Transactions'
import TeacherFeetback from '../AdminPanel/TeacherFeetback'
import SupportQuestion from '../AdminPanel/SupportQuestion'


const AdminPanelPage = (props) => {
    let {match : {params : {menu, submenu}}} = props

    let AdminComponent
    let componentProps = {}
    switch (menu) {
        case translationsAdminMenu : {
            AdminComponent = submenu ? TranslationItem : Translations
            componentProps = {
                ...componentProps,
                id : decodeURIComponent(submenu)
            }

            break
        }
        case translationsNewAdminMenu : {
            AdminComponent = TranslationItem
            break
        }
        case setttingsAdminMenu : {
            AdminComponent = Settings
            break
        }
        case usersListAdminMenu: {
            AdminComponent = UsersContainer;
            break;
        } 
        case discountsAdminMenu: {
            AdminComponent = Discounts;
            break;
        }
        case plansAdminMenu: {
            AdminComponent = Plans;
            break;
        }
        case transactionsAdminMenu: {
            AdminComponent = Transaction;
            break;
        }
        case feetbackAdminMenu: {
            AdminComponent = TeacherFeetback;
            break;
        }
        case support: {
            AdminComponent = SupportQuestion;
            break;
        }
        default : {
            AdminComponent = null
            break
        }
    }
    return (
        <AdminPanel>
            {
                AdminComponent && <AdminComponent {...componentProps} />
            }
        </AdminPanel>
    )
}

export default AdminPanelPage



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/AdminPanelPage.js